import { Dialog, IContextualMenuItem, IStackTokens, IconButton, Image, ImageFit, Label, Stack, TextField, Toggle} from '@fluentui/react';
import React, { useContext, useEffect, useState } from 'react';
import styles from '../styles/pokemon.module.scss';
import HeaderFC from './Header';
import Footer from './footerComponent';
import { TProduct, TShoppingCart, TSize } from '../constants/types';
import { SearchCards } from '../services/DBConnect';
import Shoppingcart from './shoppingcartComponent';
import { NavLink, NavigateFunction, useNavigate } from 'react-router-dom';
import PokemonCardFC from './Product/PokemonCard';
import GlobalContext from '../_contexts/GlobalContext';


export interface ISearchComponentProps {
    UpdateStateExtern: Function;
    windowSize: TSize;
    animationsEnabled: boolean;
    eurprice: number;
    satprice: number;
    onBuyClick: Function;
    onImageClick: Function;
    isDev: boolean;
    usdprice: number;
    allMenu: IContextualMenuItem[];
    shoppingkart: TShoppingCart;
    onPreCheckOut: Function;
    onSmallCartClick: Function;
    navigate: NavigateFunction;
    AlertCoachmarkVisible: boolean;
    showMessage: Function;
}

const SearchComponent : React.FunctionComponent<ISearchComponentProps> = (props : ISearchComponentProps) => {
    const [searchText,setsearchText] = useState<string>("");
    const [pageCardSet,setpageCardSet] = useState<TProduct[]>([]);
    const [showAvailableOnly,setshowAvailableOnly] = useState<boolean>(true);
    const [searchReady,setsearchReady] = useState<boolean>(true);
    const [popupUrl,setpopupUrl] = useState<string>();
    const [searchTime,setsearchTime] = useState<number>(0);   
    
    const { Strings, ImagesUrlVersionAddition } = useContext(GlobalContext);

    const cardTokens: IStackTokens = {
        childrenGap: 10,
        padding: 5
    };
   
    useEffect(() => {
        onSearchBoxChange(searchText);
    }, [showAvailableOnly]);

    function onSearchBoxChange(searchText?: string | undefined) {
        if (searchText !== searchText) {
            setsearchText(searchText);
            setsearchTime(Date.now());
            searchTicker(searchText);
        }
    }

    function searchTicker(searchText: string) {
        if (searchText !== searchText) {
            return;
        }
        if ((Date.now() - searchTime) > 300) {
            doSearch(searchText);
        } else {
            setTimeout(() => {
                searchTicker(searchText);
            }, 100);
        }
    }

    function doSearch(searchText?: string | undefined) {
        setsearchText(searchText);
        setsearchTime(0);
        
        if (searchReady === false) {
            setTimeout(() => {
                onSearchBoxChange(searchText);
            }, 200);
        } else {
            setsearchReady(false);
                SearchCards(searchText, showAvailableOnly, props.isDev).then(_cards => {
                _cards.forEach(card => {
                    if (card.number > 99) {
                        card.scardnumber = `${card.number}`;
                    } else if (card.number > 9) {
                        card.scardnumber = `0${card.number}`;
                    } else {
                        card.scardnumber = `00${card.number}`;
                    }
                    card.scardnumber += `/${card.size}`;

                    //TODO: move to backend, minimale prijs toevoegen
                    card.priceInUSD = Math.round(card.priceInUSD * 100) /100;
                    card.cost = Math.round(card.priceInUSD / props.satprice);
                    card.scost = `${card.cost}`;
                    let imageUrls: string[] = [];
                    card.imageNames.split(',').forEach(imageName => {
                        imageUrls.push(`${process.env.PUBLIC_URL}/assets/pokemon/${card.setID}/${card.number.toString()}/${imageName}?v=1`);
                    });
                    imageUrls.push(`${process.env.PUBLIC_URL}/assets/pokemon/cardback.webp`);
                    card.imageUrls = imageUrls;
                });

                _cards.sort((a,b) => a.priceInUSD < b.priceInUSD ? 1 : -1);

                setpageCardSet(_cards);
                setsearchReady(true);
            }).catch(err => {
                console.log(err);
                setsearchReady: true
            });
        }
    }

    function toggleAvailable() {
        setshowAvailableOnly(!showAvailableOnly);
    }

    function onImageClick(url:string) {
        setpopupUrl(url);
    }

    function onCheckOut() {
        props.navigate('/');
        props.onPreCheckOut();
    }

    function onSmallCartClick() {
        props.navigate('/');
        props.onSmallCartClick();
    }

    return (   
        <div className={styles.mainDiv}>
            {/* PopUp image popup*/}
            <Dialog
                hidden={!popupUrl}
                modalProps={{isBlocking: false, styles: { main : { maxHeight: props.windowSize.y - ((props.windowSize.y/100) *10), width: "100%", maxWidth: "90%!important", backgroundColor: "transparent", boxShadow: "none", overflowY:"visible", overflowX:"visible"}}}}
                onDismiss={() => {setpopupUrl(undefined);}}
            >
                <Stack horizontalAlign='center'>
                    <Image className={styles.popupImage}
                        style={{maxHeight: props.windowSize.y - ((props.windowSize.y/100) * 20)}}
                        onError={(e) => { e.currentTarget.onerror = null;
                                            e.currentTarget.src=`${process.env.PUBLIC_URL}/assets/NothingFound.webp`}}
                        onClick={() => {setpopupUrl(undefined);}}
                        src={popupUrl}
                        alt=""
                    />
                </Stack>
            </Dialog>
            <Stack horizontalAlign='center'>
                <HeaderFC />
                <div className={styles.mainSection}>
                    <div className={styles.headerMainMenu} style={{overflowY:'visible'}}>
                        <Stack horizontal style={{width:"100%"}}  >
                            <div className={styles.mainMenuItems}>
                                <Stack horizontal horizontalAlign='start' tokens={cardTokens}>
                                    <NavLink to={'/'}>
                                        <Image className={styles.homeIcon} src={`${process.env.PUBLIC_URL}/assets/Home.webp`} alt="Menu" />
                                    </NavLink>
                                </Stack>
                            </div>
                            <Stack horizontal style={{width:"100%"}} horizontalAlign='center'>
                                <div className={`${styles.mainMenuItems} ${styles.searchBox}`}>
                                    <Stack horizontal tokens={cardTokens}>
                                        <TextField  type="Search"
                                                    iconProps={{
                                                        iconName:'search',
                                                        onClick:()=> {onSearchBoxChange(searchText)}
                                                    }}
                                                    className={styles.searchBox}
                                                    value={searchText}
                                                    placeholder="Kaart zoeken"
                                                    onChange={(e,newvalue) => onSearchBoxChange(newvalue)} />
                                    </Stack>
                                </div>
                                <div className={`${styles.mainMenuItems} ${styles.mainMenuItemsBigRes}`}>
                                    <Stack tokens={cardTokens} className={`${styles.mainMenuItemsBigRes}`}>
                                        
                                    </Stack>
                                </div>
                            </Stack>
                        </Stack>
                    </div>
                    <div className={`${styles.divTable}`}>
                        <div className={styles.divTableRow}>
                            <div className={`${styles.divTableCell} ${styles.cardsSection}`}>
                                <Stack style={{whiteSpace:"nowrap",paddingTop:5,paddingLeft:5}} verticalAlign='center' horizontalAlign='start' horizontal>
                                    <Toggle label={Strings.SoldoutToggle} checked={!showAvailableOnly} inlineLabel onChange={toggleAvailable} />
                                </Stack>
                                {pageCardSet.length ?
                                    <Stack className={styles.mainSection}>
                                        <Stack horizontal style={{width:"100%", cursor:"pointer"}} > {/* onClick={() => {setshowcards: !showcards})}}> */}
                                            <Stack horizontal className={styles.boosterLabelMain}>
                                                <Stack>
                                                    <Label className={styles.boosterLabel} >{Strings.Cards}</Label>
                                                </Stack>
                                            </Stack>
                                        </Stack>
                                        <Stack horizontal wrap tokens={cardTokens} horizontalAlign='start' style={{maxWidth:""}}>
                                            {pageCardSet.map(card => {
                                                return <PokemonCardFC hideSwipe={props.windowSize.x < 800 ? false : true} 
                                                                AlertCoachmarkVisible={props.AlertCoachmarkVisible}
                                                                eurprice={props.eurprice} 
                                                                shoppingkart={props.shoppingkart}
                                                                animationsEnabled={props.animationsEnabled} 
                                                                card={card} 
                                                                onBuyClick={props.onBuyClick} />
                                            })}
                                        </Stack>
                                        <br/>
                                        <Stack horizontal horizontalAlign='center' tokens={cardTokens}>
                                            {pageCardSet.length >= 49 &&
                                            <Label>{Strings.MoreCardsSearch}</Label>}
                                        </Stack>
                                    </Stack>
                                    : <Stack horizontalAlign='center'>
                                        <Image src={process.env.PUBLIC_URL + `/assets/NothingFound.webp`} alt="" imageFit={ImageFit.contain} style={{height:300}}/>
                                        </Stack>}
                            </div>
                            <div className={`${styles.divTableCell}`} >
                                <div className={`${styles.shoppingcart}`} style={{float:"right"}}>
                                    <Stack style={{width:"100%"}} horizontalAlign='end' >
                                        <Shoppingcart eurprice={props.eurprice} 
                                                        showPopup={onImageClick} 
                                                        pShowMessage={props.showMessage}
                                                        satprice={props.satprice} 
                                                        usdprice={props.usdprice} 
                                                        shoppingcart={props.shoppingkart} 
                                                        onCheckOut={onCheckOut} 
                                                        onSmallCartClick={onSmallCartClick}/>
                                        
                                        <div className={`${styles.setLogoContainer}`}>
                                            <Stack style={{width:"100%"}} horizontalAlign='center' horizontal>
                                                <IconButton iconProps={{iconName: 'AddNotes'}} styles={{
                                                    icon: {color: 'blue', fontSize: props.windowSize.x > 960 ? 28 : 14},
                                                    root: {
                                                        margin: 0,
                                                        padding: 0,
                                                        selectors: {
                                                        '& .ms-Button-icon:hover, .ms-Button-flexContainer:hover': {
                                                            backgroundColor: 'lightblue',
                                                            color: 'darkblue'
                                                        },
                                                        }
                                                    },
                                                    }} title="Meer" src={`${process.env.PUBLIC_URL}/assets/Hamburger_icon.svg.webp`} 
                                                    menuProps={{items: props.allMenu, shouldFocusOnMount: true, subMenuHoverDelay: 250}} />
                                            </Stack>
                                        </div>
                                    </Stack>
                                </div>
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </Stack>
        </div>
    );
}

function Search(props) {
    let navigate = useNavigate();
    return <SearchComponent {...props} navigate={navigate} />
}

export default Search;